import { ICamera, IClient, IProject } from '@api/models';
import { IAiSafetyAnalysisErrorReport } from '@api/models/analytics.model';
import ImageSneakPeekModal from '@components/ImageSneakPeekModal/ImageSneakPeekModal';
import Img from '@components/Img/Img';
import useDialog from '@hooks/use-dialog';
import { Table } from '@hyperflake/react-ui-library';
import moment from 'moment';
import { Link } from 'react-router-dom';

interface AiSafetyAnalysisWrongInformationListProps {
    isLoading: boolean;
    AiSafetyAnalysis: IAiSafetyAnalysisErrorReport[];
}

// interface IDailogData {
//     imageUrl: string;
//     imageName: string;
// }

const AiSafetyAnalysisWrongInformationList = ({
    isLoading,
    AiSafetyAnalysis,
}: AiSafetyAnalysisWrongInformationListProps) => {
    const sneakPeakDialog = useDialog<IAiSafetyAnalysisErrorReport>();
    return (
        <>
            <Table
                className="mt-6"
                borderStyle="divider"
                hover={false}
                isLoading={isLoading}
                data={AiSafetyAnalysis}
                columns={[
                    { header: 'Image Name' },
                    { header: 'Client' },
                    { header: 'Project' },
                    { header: 'Camera' },
                    { header: 'Reporting Date' },
                ]}
                renderRow={(row) => (
                    <Table.Row key={row._id}>
                        <Table.Cell>
                            <div
                                className={`flex items-center ${row?.urlPreview ? 'cursor-pointer' : ''}`}
                                onClick={() => {
                                    row?.urlPreview && sneakPeakDialog.show(row);
                                }}
                            >
                                <div className="mr-1">
                                    <Img
                                        parentClassName="w-full h-9"
                                        className="w-full h-9 aspect-image rounded-md object-cover object-center "
                                        src={row.urlThumb}
                                    />
                                </div>
                                <div>{row.imageName}</div>
                            </div>
                        </Table.Cell>
                        <Table.Cell>
                            <Link
                                to={`/clients/${(row.client as IClient)._id}/client-details`}
                                className="text-primary hover:underline"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {(row.client as IClient).name}
                            </Link>
                        </Table.Cell>

                        <Table.Cell>
                            <Link
                                to={`/clients/${(row.client as IClient)._id}/projects/${
                                    (row?.project as IProject)?._id
                                }/project-details`}
                                className="text-primary hover:underline"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {(row?.project as IProject)?.name}
                            </Link>
                        </Table.Cell>
                        <Table.Cell>
                            <Link
                                to={`/clients/${(row.client as IClient)._id}/projects/${
                                    (row?.project as IProject)?._id
                                }/cameras/${(row.camera as ICamera)?._id}/edit-camera`}
                                className="text-primary hover:underline"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {(row.camera as ICamera).name}
                            </Link>
                        </Table.Cell>

                        <Table.Cell>
                            <div> {moment(row?.reportingDate, 'YYYYMMDDHHmmss').format('h:mm A DD MMM, YY')}</div>
                        </Table.Cell>
                    </Table.Row>
                )}
            />

            <ImageSneakPeekModal
                show={sneakPeakDialog.isOpen}
                onClose={sneakPeakDialog.hide}
                imageUrl={sneakPeakDialog.data?.urlPreview}
                imageName={sneakPeakDialog.data?.imageName}
                boundingBox={sneakPeakDialog.data?.boundingBox}
                resolution={sneakPeakDialog.data?.resolution}
            />
        </>
    );
};

export default AiSafetyAnalysisWrongInformationList;
